import { HubspotBrochureDownload } from ".";
import Lazyload from "react-lazy-load";
import "../../styles/contact-us.css";
import { globalHistory } from "@reach/router"
import {Trans, useTranslation} from 'gatsby-plugin-react-i18next';

const ContactUS = () => {
    const path = globalHistory.location.pathname;
    const { t } = useTranslation();
    return (
    <div>
        <section className="w-100 contact-pg-bg ">
            <div className="contact-pg-bg contact-heading text-center text-light container custom_container">
                <h1 className="font-weight-semibold py-2 section-heading text-white">
                    <Trans>Contact Us</Trans>
                </h1>
                <p
                    className="section-para font-weight-normal aos-init aos-animate text-white text-center px-5"
                    data-aos="fade-right"
                    data-aos-once="true"
                >
                    <Trans>Connecting wellness with your corporate objectives. We're
                    ready to assist! <br/> Get in Touch!</Trans>
                </p>
            </div>
            <div className="container container custom_container">
                <div className="row">
                    <div className="col-md-6 col-sm-12 contact-pg-bg">
                        <div className="container">
                            <div>
                                <div className="conatc-pageform">
                                    <Lazyload offset={10}>
                                        <HubspotBrochureDownload formID={t(`a5dc9312-cc0b-4999-8088-ed38825987e1`)}/>
                                    </Lazyload>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-md-6 col-sm-12 contact-pg-bg">
                        <div className="container">
                            <div className="w-100 d-flex flex-column justify-content-center align-items-center">
                                <div className="d-flex rectangle-contct ">
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="px-lg-4 py-4 h-100  d-flex flex-column justify-content-center">

                                                <h3 className="m-0 text-light">
                                                    <Trans i18nKey="contacttext1">Talk to our <br/><span style={{color: "#F15162"}}>sales team</span></Trans>
                                                </h3>

                                                <p className="pb-3">
                                                    <Trans>Explore our corporate wellness solutions with our dedicated sales team.</Trans>
                                                </p>
                                                <p><Trans i18nKey="contacttext2"><a href="/request-demo/" style={{color: "#F15162"}}>Request a demo</a> and experience the future of workplace well-being today!</Trans>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-4 bg-rect-2">
                                            <div className="h-100  d-flex flex-column justify-content-start align-items-center">
                                                <img
                                                    className="tele-img"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593055/VantageFit/2023/talk_to_us-contact_us_page.webp"
                                                    alt="ttu"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex rectangle-contct ">
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="px-lg-4 py-4 h-100  d-flex flex-column justify-content-center">

                                                    <h3 className="m-0 text-light">
                                                    <Trans i18nKey="contacttext3">Talk to our <br/><span style={{color: "#41D8B4"}}>customer support</span></Trans>
                                                    </h3>
                                                <p className="pb-3">
                                                    <Trans>Quick and friendly assistance for all your inquiries.</Trans>
                                                </p>
                                                <p>
                                                <Trans i18nKey="contacttext4"><a href="mailto:support@vantagecircle.com" style={{color: "#41D8B4"}}>Schedule a call</a> now!</Trans>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-4 bg-rect-2">
                                            <div className="h-100  d-flex flex-column justify-content-center align-items-center">
                                                <img
                                                    className="headph-img"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593052/VantageFit/2023/headphone-contact_us_page.webp"
                                                    alt="headphone"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex rectangle-contct ">
                                    <div className="row">
                                        <div className="col-8">
                                            <div className="px-lg-4 py-4 h-100  d-flex flex-column justify-content-center">
                                                <h3 className="m-0 text-light">
                                                <Trans i18nKey="contacttext5"><span style={{color: "#FF9D57"}}>Partner</span> <br/>with us</Trans>
                                                </h3>
                                                <p className="pb-3">
                                                    <Trans>Collaborate with Vantage Fit for a healthier workplace.</Trans>
                                                </p>
                                                <p>
                                                    <Trans i18nKey="contacttext6"><a href={t(`/partnership/`)} style={{color: "#FF9D57"}}>Partner with us</a> to elevate wellbeing and our collaborative synergy.</Trans>
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-4 bg-rect-2">
                                            <div className="h-100  d-flex flex-column justify-content-center align-items-center">
                                                <img
                                                    className="ptnr-img"
                                                    src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593054/VantageFit/2023/partnership-contact_us_page.webp"
                                                    alt="ptnr"
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section className="relative cntc-pref-pdn  vfit-loc pb-0 bg-gpref">
                <div className="p0 container custom_container">
                    <h2 className="section-heading text-light text-center">
                        <Trans>Global Presence</Trans>
                    </h2>
                    <div className="new-worldmap-img">
                        <div className="d-flex justify-content-center align-items-center loc-img-wrapper m-d-block">
                            <div className="img-1">
                                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593056/VantageFit/2023/usa-contact_us_page.webp" />
                            </div>
                            <div className="img-2">
                                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593051/VantageFit/2023/australia-contact_us_page.webp" />
                            </div>
                            <div className="img-3">
                                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593052/VantageFit/2023/india-contact_us_page.webp" />
                            </div>
                            <div className="img-4">
                                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593051/VantageFit/2023/canada-contact_us_page.webp" />
                            </div>
                            <div className="img-5">
                                <img src="https://res.cloudinary.com/vantagecircle/image/upload/v1703593052/VantageFit/2023/netherlands-contact_us_page.webp" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </section>
    </div>
    );
}

export default ContactUS;
